// src/main.jsx
// Redeploy marker 2026-08-20: Sean's staging pushes (c5bca57, 6f5ad17) were
// blocked by Vercel (commit author not a team member); this no-op commit,
// authored by a team account, rebuilds the same code.
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import ErrorBoundary from './components/shared/ErrorBoundary.jsx';
import { initSentry } from './utils/sentry';
import './index.css';

// Before anything renders, so a crash during the first paint is still reported.
initSentry();

// Two boundaries on purpose. This outer one catches anything the routed
// boundary can't — the provider, the router, the connectivity chrome — and is
// the difference between a recoverable screen and a permanently blank tab.
createRoot(document.getElementById('root')).render(
  <ErrorBoundary scope="root">
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ErrorBoundary>
);
